/**
 * Pure layout helpers for side-by-side rooms: the layout-mode list, per-device
 * preference persistence (localStorage), and the PiP corner-snap geometry.
 * No DOM beyond localStorage — kept isolated so the logic is unit-testable.
 */

export const LAYOUTS = ['side', 'topbottom', 'pip'];
export const DEFAULT_LAYOUT = 'side';
export const PIP_CORNERS = ['tl', 'tr', 'bl', 'br'];
export const DEFAULT_PIP_CORNER = 'tl';

const LAYOUT_KEY = 'retroplay:sbsLayout';
const CORNER_KEY = 'retroplay:sbsPipCorner';

/** Saved layout mode, falling back to the default for missing/invalid values. */
export function loadLayout() {
  try {
    const v = localStorage.getItem(LAYOUT_KEY);
    return LAYOUTS.includes(v) ? v : DEFAULT_LAYOUT;
  } catch { return DEFAULT_LAYOUT; }
}

/** Persist the layout mode (no-op if invalid or storage unavailable). */
export function saveLayout(mode) {
  if (!LAYOUTS.includes(mode)) return;
  try { localStorage.setItem(LAYOUT_KEY, mode); } catch { /* storage unavailable */ }
}

/** Saved PiP corner, falling back to the default for missing/invalid values. */
export function loadPipCorner() {
  try {
    const v = localStorage.getItem(CORNER_KEY);
    return PIP_CORNERS.includes(v) ? v : DEFAULT_PIP_CORNER;
  } catch { return DEFAULT_PIP_CORNER; }
}

/** Persist the PiP corner (no-op if invalid or storage unavailable). */
export function savePipCorner(corner) {
  if (!PIP_CORNERS.includes(corner)) return;
  try { localStorage.setItem(CORNER_KEY, corner); } catch { /* storage unavailable */ }
}

/**
 * Nearest corner for a PiP overlay, by comparing its center to the container
 * mid-lines. `rect` = { left, top, width, height } (relative to the container);
 * `container` = { width, height }. Returns 'tl' | 'tr' | 'bl' | 'br'.
 */
export function nearestCorner(rect, container) {
  const cx = rect.left + rect.width / 2;
  const cy = rect.top + rect.height / 2;
  const vert = cy < container.height / 2 ? 't' : 'b';
  const horiz = cx < container.width / 2 ? 'l' : 'r';
  return vert + horiz;
}
